(() => {
  'use strict';
  const mobile = matchMedia('(max-width:767.98px)');
  let pending = null;
  let resetTimer;
  const warmed = new Set();
  function preorderLink(target) {
    const link = target.closest('#mobile_menu a[href]');
    if (!link) return null;
    const url = new URL(link.href, location.href);
    return url.origin === location.origin && url.searchParams.get('view') === 'preorders' ? link : null;
  }
  function warmPreorders() {
    if (!mobile.matches || navigator.connection && navigator.connection.saveData) return;
    document.querySelectorAll('#mobile_menu a[href]').forEach(link => {
      if (!preorderLink(link) || warmed.has(link.href)) return;
      warmed.add(link.href);
      const hint = document.createElement('link');
      hint.rel = 'prefetch'; hint.as = 'document'; hint.href = link.href;
      document.head.append(hint);
    });
  }
  function resetPending() {
    clearTimeout(resetTimer);
    if (!pending) return;
    pending.link.removeAttribute('aria-busy');
    pending.label.remove();
    pending = null;
  }
  document.addEventListener('click', event => {
    if (!mobile.matches) return;
    if (event.target.closest('[aria-controls="mobile_menu"],#show-megamenu')) warmPreorders();
    const link = preorderLink(event.target);
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (pending && pending.link === link) { event.preventDefault(); return; }
    resetPending();
    const label = document.createElement('span');
    label.setAttribute('role', 'status');
    label.className = 'enigma-mobile-preorder-spinner';
    label.setAttribute('aria-label', document.documentElement.lang.startsWith('it') ? 'Caricamento' : 'Loading');
    label.innerHTML = '<span class="enigma-mobile-preorder-hex" aria-hidden="true"></span>';
    link.append(label); link.setAttribute('aria-busy', 'true');
    pending = { link, label };
    // Keep the first activation native; allow retry if navigation fails.
    resetTimer = setTimeout(resetPending, 15000);
  });
  window.addEventListener('pageshow', resetPending);
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-enigma-mobile-menu-close]')) return;
    if (window.novtheme && typeof window.novtheme.closeMobileMenu === 'function') {
      window.novtheme.closeMobileMenu(true);
    }
  });
})();
